import Component from '../core/Component'
import {EMITS as SLIDER_EMITS} from './Slider'

export default class HomepageRooms extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            progress: null,
            slider: null,
            links: []
        }
    }

    prepare() {
        this.progress = Component.getFromElement(this.ref.progress)
        this.slider = Component.getFromElement(this.ref.slider)

        this.slider.on(SLIDER_EMITS.SELECTED, this.handleSliderSelected)

        this.ref.links.forEach(link => link.addEventListener('click', this.handleLinkClick))
    }

    handleSliderSelected = data => {
        const index = data.index

        this.ref.links.forEach(link => link.classList.remove('is-active'))
        this.ref.links[index].classList.add('is-active')

        this.progress.setContent(this.ref.links[index].innerText)

        const progress = this.ref.links.length > 1 ? index / (this.ref.links.length - 1) : 0
        this.progress.setProgress(progress)
    }

    handleLinkClick = event => {
        event.preventDefault()

        const index = this.ref.links.findIndex(link => link === event.currentTarget)

        if (~index) {
            this.slider.select(index)
        }
    }
}